import { BrandRepository } from '@/core/brand/domain/BrandRepository.ts'
import { Brand } from '@/core/brand/domain/Brand.ts'

type GetBrandsUseCaseDependencies = { brandRepository: BrandRepository }

export class GetBrandsUseCase {
  private readonly brandRepository: BrandRepository
  constructor({ brandRepository }: GetBrandsUseCaseDependencies) {
    this.brandRepository = brandRepository
  }

  execute = (hostId: string): Promise<Brand[]> => {
    return this.brandRepository.getBrands(hostId)
  }
}
